import { makeStyles } from '@material-ui/core';
import { COLORS } from 'constants/index';

export const useStyles = makeStyles({
  iconCircle: {
    width: '40px',
    height: '40px',
    backgroundColor: COLORS.GRAY_08,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconPadding: {
    paddingLeft: ({ alignLeft }: any) => alignLeft ? '0' : '8px',
  }
});